import React from "react";
import SiderMenuWidget from "../Widget/SiderMenuWidget";
import RecentPostWidget from "../Widget/RecentPostWidget";
const categoryData = [
];
const recentPostData = [
  {
    title: `Can’t Conceive Naturally? IVF and ICSI Might Be the Key`,
    author: "Dr. Archana Srivastava",
    date: "14 May, 2025",
    href: "/can-not-conceive-naturally-IVF-and-ICSI-Might-Be-the-Key",
  },
  {
    title: `Pluro Jabalpur IVF Center: Pioneering Advanced Fertility Solutions for Couples`,
    author: "Dr. Archana Srivastava",
    date: "06 May, 2025",
    href: "/best-fertility-clinic-jabalpur-ivf-treatment",
  },
  {
    title: `Best Treatment for Oligospermia – Pluro Jabalpur Fertility Centre`,
    author: "Dr. Archana Srivastava",
    date: "24 April, 2025",
    href: "/best-treatment-for-oligospermia",
  },
  {
    title: `Best Gynecologist and Obstetrician in Jabalpur – Dr. Archana Shrivastavaa`,
    author: "Dr. Archana Srivastava",
    date: "14 April, 2025",
    href: "/best-gynecologist-obstetrician-jabalpur",
  },
  {
    title: `Male Infertility Treatment in Jabalpur: Meet the Best Doctors for Fertility Solutions`,
    author: "Dr. Archana Srivastava",
    date: "21 March, 2025",
    href: "/Male-Infertility-Treatment-in-Jabalpur-Meet-the-Best-Doctors-for-Fertility-Solutions",
  },
].map(item => ({
  ...item,
  author: "Pluro Jabalpur Fertility Center"
}));

export default function Sidebar() {
  return (
    <div className="cs_sidebar">
      <div
      // className="cs_sidebar_item widget_categories"
      >
        <SiderMenuWidget title="Popular Categories" data={categoryData} />
      </div>
      <div className="cs_sidebar_item">
        <RecentPostWidget title="Popular Articles" data={recentPostData} />
      </div>
      {/* <div className="cs_sidebar_item widget_categories">
        <NewsletterStyle5 title="Newsletter Sign Up Form" />
      </div> */}
    </div>
  );
}
